export const TemplateType = {
  setTemplateModal: "SETTEMPLATEMODAL",
  setTemplateData: "SETTEMPLATEDATA",
  closeTemplateModal: "CLOSETEMPLATEMODAL",
  setTemplateId: "SETTEMPLATEID",
  clearTemplateData: "CLEARTEMPLATEDATA",
  setTemplateGetData: "SETTEMPLATEGETDATA",
  setSubmit: "SETSUBMIT"
};
